'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  loadingContent: PropTypes.node,
  props: PropTypes.object.isRequired,
  requirement: PropTypes.func.isRequired
};
const defaultProps = {
  loadingContent: null,
  props: {}
};
const initialState = {
  Result: null
};
export default class AsyncComponent extends Component {
  constructor() {
    super();
    this.state = initialState;
  }
  componentDidMount() {
    this._isMounted = true;
    this.props.requirement(Result => {
      if (this._isMounted) {
        this.setState({
          Result
        });
      }
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const {
      loadingContent,
      props
    } = this.props;
    const {
      Result
    } = this.state;
    if (!Result) {
      return loadingContent;
    }
    return /*#__PURE__*/_jsx(Result, Object.assign({}, props));
  }
}
AsyncComponent.defaultProps = defaultProps;
AsyncComponent.propTypes = propTypes;